import { send } from 'server';

export const unblockAccount = ({ casinoName, token }) => send({
        ID: 35668,
        description: 'Invoke action',
        responses: [35669, 35670],
        token,
        casino: casinoName
});
